import { Card } from "react-bootstrap";
import CustomStore from "devextreme/data/custom_store";
import React, { useCallback, useMemo, useRef, useState, } from "react";
import { getAllDiamondInwardData } from "../services/diamond-product-inward.service";
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Selection, Summary, TotalItem } from "devextreme-react/cjs/data-grid";
import { updateGoldAndDiamondInwardRecords } from "utils/inward";
import { HttpStatus, UpdateInwardDataIds } from "modules/core";
import notistack from "modules/core/notistack";
import { spawn } from "child_process";
import useMenuData from "Layout/LayoutMenuData";
import { HasPermission } from "Layout/Permissions/permissionsCache";

const DiamondProductInward = () => {
    const { loadStats } = useMenuData()

    let setSelectedRows: Array<number> = [];
    const dataGridRef = useRef<DataGrid>(null);

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const { searchValue, skip, take } = loadOptions;
                    const parameterList = new URLSearchParams();
                    if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                    if (typeof take === 'number') parameterList.append('take', take.toString());
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }
                    if (searchValue) {
                        parameterList.append("search", searchValue);
                    }
                    parameterList.append("MaterialType", 'diamond');
                    parameterList.append("IsSNMCC", 'false');
                    parameterList.append("IsReceived", 'false');
                    const response = await getAllDiamondInwardData(parameterList);
                    return response
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    }

    const handleSelectionChange = (e: any) => {
        setSelectedRows = e.selectedRowsData.map((item: any) => item.id);
    };

    const renderSerialNumber = useCallback((cellData: any) => {
        const rowIndex = cellData.rowIndex + 1 + cellData.component.pageIndex() * cellData.component.pageSize();
        return <span>{rowIndex}</span>;
    }, []);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const updateDiamondAndGoldInword = async () => {
        try {
            await loadStats();
            if (setSelectedRows.length > 0) {
                const model = new UpdateInwardDataIds();
                model.productHeaderIdList = setSelectedRows;
                setIsSubmitting(true);
                const response = await updateGoldAndDiamondInwardRecords(model);
                if (response.status === 200) {
                    dataGridRef.current?.instance.clearSelection();
                    dataGridRef.current?.instance.refresh();
                    notistack.notifyFromApi(response);
                } else {
                    notistack.notifyFromApi(response);
                }
            } else {
                notistack.warning("Please Select Product");
            }
        } catch (error) {
            console.error("Failed to fetch inward Data:", error);
        } finally {
            await loadStats();
            setIsSubmitting(false);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Diamond Inward   </h5>
                            {HasPermission('ProductHeader.Write') && <button onClick={updateDiamondAndGoldInword} className="submit-btn" disabled={isSubmitting}>
                                Receive
                            </button>}
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {HasPermission('ProductHeader.Read') &&
                                <DataGrid
                                    dataSource={dataSource()}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    ref={dataGridRef}
                                    showBorders={true}
                                    columnAutoWidth={true}
                                    onSelectionChanged={handleSelectionChange}
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                >
                                    <Scrolling
                                        mode='standard'
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />
                                    <Selection
                                        mode="multiple"
                                    />

                                    <Pager
                                        // visible={true}
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <Summary>
                                        <TotalItem
                                        // column="Sr.No."
                                        // summaryType="count"
                                        // displayFormat="Total: {0}"
                                        />
                                    </Summary>
                                    <Paging defaultPageSize={10} />
                                    <SearchPanel visible width={240} placeholder="Search..." />

                                    <Column
                                        cssClass="text-center" caption="Sr.No."
                                        dataType="number"
                                        alignment="center"
                                        cellRender={renderSerialNumber}
                                    />
                                    <Column allowFiltering={true} dataField="storeCode" cssClass="text-center" caption="Store Code" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="invoiceNo" cssClass="text-center" caption="Invoice No." dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="invoiceDate" cssClass="text-center" caption="Invoice Date" dataType="date" format="dd/MM/yyyy" width={150} />
                                    <Column allowFiltering={true} dataField="styleNo" cssClass="text-center" caption="Style Number" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="categoryName" cssClass="text-center" caption="Category Name" dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="diaWt" format="#,##0.000" cssClass="text-center" caption="Diamond Weight" dataType="number" width={150} />
                                    <Column allowFiltering={false} dataField="diaQty" cssClass="text-center" caption="Diamond Quality" dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="netWt" format="#,##0.000" cssClass="text-center" caption="Net Weight" dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="grossWt" format="#,##0.000" cssClass="text-center" caption="Gross Weight" dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="metalKT" format="#,##0.000" cssClass="text-center" caption="Metal KT" dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="qty" cssClass="text-center" caption="Quantity" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="certificateNo" cssClass="text-center" caption="IGI Number" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="huid" cssClass="text-center" caption="HUID" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="bagNo" cssClass="text-center" caption="BagNo." dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="dpPrice" format="#,##0.00" cssClass="text-center" caption="Depository Participant Price" dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="mrpPrice" format="#,##0.00" cssClass="text-center" caption="Selling Price" dataType="string" width={150} />
                                    <Column allowFiltering={false}
                                        dataField="isSRP"
                                        cssClass="text-center" caption="Is SRP" dataType="boolean"
                                        width={150}
                                        cellRender={({ data }) => (
                                            <span>{data?.isSRP ? "SRP" : "MRP"}</span>
                                        )}
                                    />

                                </DataGrid>}
                        </Card.Body>
                    </Card>
                </div>
            </div >
        </React.Fragment >
    );
}
export default DiamondProductInward;